// import React, { useState } from "react";
// import { Modal, Tooltip } from "antd";
// import { useHistory, useLocation } from "react-router-dom";
// import { BiSolidDashboard } from "react-icons/bi";
// import { APP_ROUTES } from "../PageRouting/PageRoutes";
// import {
//   MdAnalytics,
//   MdOutlineSwitchAccount,
//   MdWorkHistory,
// } from "react-icons/md";
// import { HiOutlineLogout, HiUserGroup } from "react-icons/hi";
// import { LuCalendarClock, LuPresentation } from "react-icons/lu";
// import { TbReport, TbReportMedical } from "react-icons/tb";
// import { FaCcMastercard, FaClipboardList } from "react-icons/fa";
// import { IoNotifications, IoSettings } from "react-icons/io5";
// import { CiViewList } from "react-icons/ci";
// import { PiUserListFill } from "react-icons/pi";
// import { FaProcedures } from "react-icons/fa";
// import { FaUserDoctor } from "react-icons/fa6";
// import { FaWpforms } from "react-icons/fa6";
// import { MdJoinLeft } from "react-icons/md";
// import { BsCashCoin } from "react-icons/bs";
// import { MdDiscount } from "react-icons/md";
// import { FaFileInvoice } from "react-icons/fa";
// import memberShip from "../Assets/Images/SideMenuSVG/membershipIcon.svg";
// import AppointmentService from "../Services/AppointmentService";
// import { useNavigation } from "../Context/NavigationContext";
// import { useDispatch } from "react-redux";
// import { RESET_STORE } from "../store";

// function Sidemenu({ isMenuOpen, handleSideBarMenu }) {
//   const [currOpenTab, setCurrOpenTab] = useState("");
//   const location = useLocation();
//   const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
//   const [isRpmSubMenuOpen, setIsRpmSubMenuOpen] = useState(false);
//   const [logoutModal, setLogoutModal] = useState(false);
//   const [showWarning, setShowWarning] = useState(false);
//   const [pageRoute, setPageRoute] = useState("");
//   const history = useHistory();
//   const loggedUserObj = sessionStorage.getItem("login_result");
//   const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
//   const isSuperAdmin = loggedUser?.user?.rolecode === "SUPERADMIN";
//   const { navigate, isPending } = useNavigation();

//   const dispatch = useDispatch();

//   const handleTab = (tab) => {
//     setCurrOpenTab(tab);
//   };

//   const isMenuItemActive = (path) => {
//     return location.pathname === path;
//   };

//   const handleNavigation = (path) => {
//     if (location.pathname === APP_ROUTES.VIDEOCALL) {
//       setPageRoute(path);
//       setShowWarning(true);
//     } else {
//       if (
//         APP_ROUTES.ACCOUNTS !== path &&
//         APP_ROUTES.CLINIC !== path &&
//         APP_ROUTES.USER !== path &&
//         APP_ROUTES.USERCLINICS !== path &&
//         APP_ROUTES.USERTEMPLATES !== path
//       ) {
//         setIsSubMenuOpen(false);
//       }

//       if (
//         APP_ROUTES.RPMVITALPARAMS !== path &&
//         APP_ROUTES.RPMTASKFREQUENCY !== path &&
//         APP_ROUTES.DEVICESETUP !== path &&
//         APP_ROUTES.RPMBILLINGREPORT !== path &&
//         APP_ROUTES.RPMDASHBOARD !== path
//       ) {
//         setIsRpmSubMenuOpen(false);
//       }
//       navigate(path);
//     }
//   };

//   const handleLogout = () => {
//     if (location.pathname === APP_ROUTES.VIDEOCALL) {
//       setPageRoute(APP_ROUTES.LOGIN);
//       setShowWarning(true);
//     } else {
//       setLogoutModal(true);
//     }
//   };

//   const handleCancel = () => {
//     setLogoutModal(false);
//   };

//   const handleOk = () => {
//     sessionStorage.clear();
//     sessionStorage.clear();
//     dispatch({ type: RESET_STORE });
//     setLogoutModal(false);
//     setTimeout(() => {
//       navigate(APP_ROUTES.LOGIN);
//     }, 500);
//   };

//   const handleVideoCallRoute = () => {
//     setShowWarning(false);
//   };

//   const handleVideoNavigation = async () => {
//     if (
//       location.pathname === APP_ROUTES.VIDEOCALL &&
//       pageRoute === APP_ROUTES.LOGIN
//     ) {
//       setShowWarning(false);
//       sessionStorage.clear();
//       setTimeout(() => {
//         navigate(APP_ROUTES.LOGIN);
//       }, 500);
//     } else {
//       setShowWarning(false);
//       const apptJson = sessionStorage.getItem("appt");
//       const selectedAppointment = apptJson ? JSON.parse(apptJson) : null;
//       let payload = {
//         appointmentId: selectedAppointment.appointmentId,
//         patientId: selectedAppointment.patientId,
//         userId: selectedAppointment.userId,
//         queueStatus: "N",
//       };
//       try {
//         await AppointmentService.updateQueueStatus(payload);
//         sessionStorage.removeItem("appt");
//         navigate(pageRoute || APP_ROUTES.DASHBOARD);
//       } catch (e) {
//         console.log(e);
//       }
//     }
//   };

//   return (
//     <div className="sidemenu fixed z-10 border-r border-t border-b border-brand-borderColor w-[inherit] overflow-y-auto rounded-r-lg  bg-white">
//       <ul
//         className={`mt-1 flex flex-col gap-2 justify-evenly items-center mx-1`}
//       >
//     <li className="w-full">
//   <div
//     onClick={() => handleNavigation(APP_ROUTES.DASHBOARD)}
//     className={`
//       flex items-center gap-4
//       px-3 py-3
//       rounded-md
//       cursor-pointer
//       transition-all duration-200
//       ${
//         isMenuItemActive(APP_ROUTES.DASHBOARD)
//           ? "bg-[#E8FAF7]"
//           : "hover:bg-[#F5FAFA]"
//       }
//     `}
//   >
//     <BiSolidDashboard
//       className={`
//         w-7 h-7 shrink-0
//         ${
//           isMenuItemActive(APP_ROUTES.DASHBOARD)
//             ? "text-[#0CB8A1]"
//             : "text-[#6E879B]"
//         }
//       `}
//     />

//     {isMenuOpen && (
//       <span className="text-[18px] font-medium text-[#16285C]">
//         Dashboard
//       </span>
//     )}
//   </div>
// </li>

//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.NEWANALYTICS)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.NEWANALYTICS)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Analytics"}>
//                 <MdAnalytics
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.NEWANALYTICS)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.NEWANALYTICS)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Analytics
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.PATIENTLIST)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.PATIENTLIST)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Patient List"}>
//                 <HiUserGroup
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.PATIENTLIST)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               }  ${
//                 isMenuItemActive(APP_ROUTES.PATIENTLIST)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Patient List
//             </span>
//           </div>
//         </li>

//         {/* ------ RPM side menu option starts -----  */}
//         {loggedUser?.user &&
//           (loggedUser.user.rolecode === "SUPERADMIN" ||
//             loggedUser.user.rpmApplicable === "Y") && (
//             <li
//               className="w-full cursor-pointer flex items-center flex-col"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 if (!isMenuOpen) {
//                   handleSideBarMenu();
//                 }
//                 !isRpmSubMenuOpen && setIsRpmSubMenuOpen(true);
//                 handleTab("rpm");
//               }}
//             >
//               <div className="w-full flex items-center my-1">
//                 <Tooltip placement="right" color="Teal" title={"RPM"}>
//                   <MdOutlineSwitchAccount
//                     className={`h-5 w-5 ${isMenuOpen ? "mr-3 ml-2" : "ml-2"} ${
//                       location.pathname === "/vitalparams" ||
//                       location.pathname === "/taskfrequency" ||
//                       location.pathname === "/devicesetup" ||
//                       location.pathname === "/rpmbillingreport"
//                         ? " text-black"
//                         : "text-black"
//                     }`}
//                   />
//                 </Tooltip>
//                 <div>
//                   <span
//                     className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                       !isMenuOpen ? "hidden" : ""
//                     }`}
//                   >
//                     RPM
//                   </span>
//                 </div>
//               </div>
//               {isRpmSubMenuOpen && (
//                 <ul className="pl-2.5">
//                   <li className="flex gap-3 items-center px-1 py-2">
//                     {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                     <div
//                       onClick={() => handleNavigation(APP_ROUTES.RPMDASHBOARD)}
//                       className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                     >
//                       <Tooltip
//                         placement="right"
//                         color="Teal"
//                         title={"Rpm Dashboard"}
//                       >
//                         <FaClipboardList
//                           className={`h-5 w-5 ${
//                             isMenuItemActive(APP_ROUTES.RPMDASHBOARD)
//                               ? " text-black rounded-lg"
//                               : "text-black"
//                           }`}
//                         />
//                       </Tooltip>
//                       <span
//                         className={`font-sans font-semibold text-sm text-[#041346] ${
//                           !isMenuOpen ? "hidden" : ""
//                         } ${
//                           isMenuItemActive(APP_ROUTES.RPMDASHBOARD)
//                             ? "font-semibold text-sm"
//                             : ""
//                         }`}
//                       >
//                         Dashboard
//                       </span>
//                     </div>
//                   </li>
//                   <li className="flex gap-3 items-center px-1 py-2">
//                     {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                     <div
//                       onClick={() =>
//                         handleNavigation(APP_ROUTES.RPMVITALPARAMS)
//                       }
//                       className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2 cursor-pointer"
//                     >
//                       <Tooltip
//                         placement="right"
//                         color="Teal"
//                         title={"Vital Parameters"}
//                       >
//                         <CiViewList
//                           className={`h-5 w-5 ${
//                             isMenuItemActive(APP_ROUTES.RPMVITALPARAMS)
//                               ? " text-black"
//                               : "text-black rounded-lg"
//                           }`}
//                         />
//                       </Tooltip>
//                       <span
//                         className={`font-sans font-semibold text-sm text-[#041346] ${
//                           !isMenuOpen ? "hidden" : ""
//                         } ${
//                           isMenuItemActive(APP_ROUTES.RPMVITALPARAMS)
//                             ? "text- font-semibold text-sm"
//                             : "text-black"
//                         }`}
//                       >
//                         Vital Parameters
//                       </span>
//                     </div>
//                   </li>
//                   <li className="flex gap-3 items-center px-1 py-2">
//                     {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                     <div
//                       onClick={() =>
//                         handleNavigation(APP_ROUTES.RPMTASKFREQUENCY)
//                       }
//                       className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                     >
//                       <Tooltip placement="right" color="Teal" title={"Task"}>
//                         <FaClipboardList
//                           className={`h-5 w-5 ${
//                             isMenuItemActive(APP_ROUTES.RPMTASKFREQUENCY)
//                               ? " text-black rounded-lg"
//                               : "text-black"
//                           }`}
//                         />
//                       </Tooltip>
//                       <span
//                         className={`font-sans font-semibold text-sm text-[#041346] ${
//                           !isMenuOpen ? "hidden" : ""
//                         } ${
//                           isMenuItemActive(APP_ROUTES.RPMTASKFREQUENCY)
//                             ? "font-semibold text-sm"
//                             : ""
//                         }`}
//                       >
//                         Task/Frequency
//                       </span>
//                     </div>
//                   </li>
//                   <li className="flex gap-3 items-center px-1 py-2">
//                     <div
//                       onClick={() => handleNavigation(APP_ROUTES.DEVICESETUP)}
//                       className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                     >
//                       <Tooltip
//                         placement="right"
//                         color="Teal"
//                         title={"Device setup"}
//                       >
//                         <MdJoinLeft
//                           className={`h-5 w-5 ${
//                             isMenuItemActive(APP_ROUTES.DEVICESETUP)
//                               ? " text-black rounded-lg"
//                               : "text-black"
//                           }`}
//                         />
//                       </Tooltip>

//                       <span
//                         className={`font-sans font-semibold text-sm text-[#041346] ${
//                           !isMenuOpen ? "hidden" : ""
//                         } ${
//                           isMenuItemActive(APP_ROUTES.DEVICESETUP)
//                             ? "text-black font-semibold text-sm"
//                             : ""
//                         }`}
//                       >
//                         Device setup
//                       </span>
//                     </div>
//                   </li>
//                   <li className="flex gap-3 items-center px-1 py-2">
//                     <div
//                       onClick={() =>
//                         handleNavigation(APP_ROUTES.RPMACTIVITYREPORT)
//                       }
//                       className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                     >
//                       <Tooltip
//                         placement="right"
//                         color="Teal"
//                         title={"User Mapped Clinics"}
//                       >
//                         <MdJoinLeft
//                           className={`h-5 w-5 ${
//                             isMenuItemActive(APP_ROUTES.RPMACTIVITYREPORT)
//                               ? " text-black rounded-lg"
//                               : "text-black"
//                           }`}
//                         />
//                       </Tooltip>

//                       <span
//                         className={`font-sans font-semibold text-sm text-[#041346] ${
//                           !isMenuOpen ? "hidden" : ""
//                         } ${
//                           isMenuItemActive(APP_ROUTES.RPMACTIVITYREPORT)
//                             ? "text-black font-semibold text-sm"
//                             : ""
//                         }`}
//                       >
//                         Activity Report
//                       </span>
//                     </div>
//                   </li>
//                 </ul>
//               )}
//             </li>
//           )}
//         {/* ------ RPM side menu option ends ---- */}
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.APPOINMENTS)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.APPOINMENTS)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Appointments"}>
//                 <LuCalendarClock
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.APPOINMENTS)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.APPOINMENTS)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Appointments
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.PROCEDURE)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.PROCEDURE)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Procedures"}>
//                 <FaProcedures
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.PROCEDURE)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.PROCEDURE)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Procedures
//             </span>
//           </div>
//         </li>
//         <li
//           className="w-full cursor-pointer flex items-center flex-col"
//           onClick={() => {
//             if (!isMenuOpen) {
//               handleSideBarMenu();
//             }
//             !isSubMenuOpen && setIsSubMenuOpen(true);
//             handleTab("accounts");
//           }}
//         >
//           <div className="w-full flex items-center my-1">
//             <Tooltip placement="right" color="Teal" title={"Accounts"}>
//               <MdOutlineSwitchAccount
//                 className={`h-5 w-5 ${isMenuOpen ? "mr-3 ml-2" : "ml-2"} ${
//                   location.pathname === "/accounts" ||
//                   location.pathname === "/clinics" ||
//                   location.pathname === "/users"
//                     ? " text-black"
//                     : "text-black"
//                 }`}
//               />
//             </Tooltip>
//             <div>
//               <span
//                 className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                   !isMenuOpen ? "hidden" : ""
//                 }`}
//               >
//                 Accounts
//               </span>
//             </div>
//           </div>
//           {isSubMenuOpen && (
//             <ul>
//               <li className="flex gap-3 items-center px-1 py-2">
//                 {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.ACCOUNTS)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2 cursor-pointer"
//                 >
//                   <Tooltip
//                     placement="right"
//                     color="Teal"
//                     title={"Account List"}
//                   >
//                     <CiViewList
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.ACCOUNTS)
//                           ? " text-black"
//                           : "text-black rounded-lg"
//                       }`}
//                     />
//                   </Tooltip>
//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.ACCOUNTS)
//                         ? "text- font-semibold text-sm"
//                         : "text-black"
//                     }`}
//                   >
//                     Account List
//                   </span>
//                 </div>
//               </li>
//               <li className="flex gap-3 items-center px-1 py-2">
//                 {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.CLINIC)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                 >
//                   <Tooltip placement="right" color="Teal" title={"Clinic List"}>
//                     <FaClipboardList
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.CLINIC)
//                           ? " text-black rounded-lg"
//                           : "text-black"
//                       }`}
//                     />
//                   </Tooltip>
//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.CLINIC)
//                         ? "font-semibold text-sm"
//                         : ""
//                     }`}
//                   >
//                     Branch List
//                   </span>
//                 </div>
//               </li>
//               <li className="flex gap-3 items-center px-1 py-2">
//                 {/* <PiDiamondBold className="text-black   md:text-[10px] text-[5px]" /> */}
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.USER)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                 >
//                   <Tooltip placement="right" color="Teal" title={"User List"}>
//                     <PiUserListFill
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.USER)
//                           ? " text-black rounded-lg"
//                           : "text-black"
//                       }`}
//                     />
//                   </Tooltip>

//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.USER)
//                         ? "text-black font-semibold text-sm"
//                         : ""
//                     }`}
//                   >
//                     User List
//                   </span>
//                 </div>
//               </li>
//               <li className="flex gap-3 items-center px-1 py-2">
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.USERTEMPLATES)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                 >
//                   <Tooltip
//                     placement="right"
//                     color="Teal"
//                     title={"User Mapped Templates"}
//                   >
//                     <MdJoinLeft
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.USERTEMPLATES)
//                           ? " text-black rounded-lg"
//                           : "text-black"
//                       }`}
//                     />
//                   </Tooltip>

//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.USERTEMPLATES)
//                         ? "text-black font-semibold text-sm"
//                         : ""
//                     }`}
//                   >
//                     Mapped Temp.
//                   </span>
//                 </div>
//               </li>
//               <li className="flex gap-3 items-center px-1 py-2">
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.USERCLINICS)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                 >
//                   <Tooltip
//                     placement="right"
//                     color="Teal"
//                     title={"User Mapped Clinics"}
//                   >
//                     <MdJoinLeft
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.USERCLINICS)
//                           ? " text-black rounded-lg"
//                           : "text-black"
//                       }`}
//                     />
//                   </Tooltip>

//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.USERCLINICS)
//                         ? "text-black font-semibold text-sm"
//                         : ""
//                     }`}
//                   >
//                     Mapped Clinics
//                   </span>
//                 </div>
//               </li>
//               <li
//                 className={`gap-3 items-center px-1 py-2 ${isSuperAdmin ? "flex" : "hidden"}`}
//               >
//                 <div
//                   onClick={() => handleNavigation(APP_ROUTES.ENROLLEDUSER)}
//                   className="md:font-normal font-extralight md:text-sm text-xs text-bgBlue flex items-center gap-2"
//                 >
//                   <Tooltip
//                     placement="right"
//                     color="Teal"
//                     title={"Enrolled List"}
//                   >
//                     <PiUserListFill
//                       className={`h-5 w-5 ${
//                         isMenuItemActive(APP_ROUTES.ENROLLEDUSER)
//                           ? " text-black rounded-lg"
//                           : "text-black"
//                       }`}
//                     />
//                   </Tooltip>

//                   <span
//                     className={`font-sans font-semibold text-sm text-[#041346] ${
//                       !isMenuOpen ? "hidden" : ""
//                     } ${
//                       isMenuItemActive(APP_ROUTES.ENROLLEDUSER)
//                         ? "text-black font-semibold text-sm"
//                         : ""
//                     }`}
//                   >
//                     Enrolled List
//                   </span>
//                 </div>
//               </li>
//             </ul>
//           )}
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.TEMPLATES)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.TEMPLATES)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.TEMPLATES) ? " rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Templates"}>
//                 <FaWpforms
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.TEMPLATES)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.TEMPLATES)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Templates
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.SPECIALITYTEMPMAP)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.SPECIALITYTEMPMAP)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.SPECIALITYTEMPMAP)
//                   ? "rounded-md"
//                   : ""
//               }`}
//             >
//               <Tooltip
//                 placement="right"
//                 color="Teal"
//                 title={"Speciality-Templates Mapping"}
//               >
//                 <MdJoinLeft
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.SPECIALITYTEMPMAP)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.SPECIALITYTEMPMAP)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Sp.Mapping
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.PROCEDURAL)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.PROCEDURAL)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.PROCEDURAL) ? " rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"OP services"}>
//                 <FaProcedures
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.PROCEDURAL)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.PROCEDURAL)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               OP services
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.VIRTUALCASH)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.VIRTUALCASH)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.VIRTUALCASH) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Virtual Cash"}>
//                 <BsCashCoin
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.VIRTUALCASH)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.VIRTUALCASH)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Virtual Cash
//             </span>
//           </div>
//         </li>

//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.INVOICE)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.INVOICE)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.INVOICE) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Invoice"}>
//                 <FaFileInvoice
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.INVOICE)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.INVOICE)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Invoice
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.MEMBERSHIP)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.MEMBERSHIP)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.MEMBERSHIP) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Membership"}>
//                 <img
//                   src={memberShip}
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.MEMBERSHIP)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                   alt="membership"
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.MEMBERSHIP)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Membership
//             </span>
//           </div>
//         </li>
//         <li className={`w-full ${isSuperAdmin ? "flex" : "hidden"}`}>
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.DEMOREQUESTS)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.DEMOREQUESTS)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.DEMOREQUESTS) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Demo Requests"}>
//                 <LuPresentation
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.DEMOREQUESTS)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.DEMOREQUESTS)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Demo Requests
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.DISCOUNT)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.DISCOUNT)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.DISCOUNT) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Discount"}>
//                 <MdDiscount
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.DISCOUNT)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.DISCOUNT)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Discount
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.PAYMENTS)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.PAYMENTS)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.PAYMENTS) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Payments"}>
//                 <FaCcMastercard
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.PAYMENTS)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.PAYMENTS)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Payments
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.BILLINGREPORT)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.BILLINGREPORT)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.BILLINGREPORT) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Billing Report"}>
//                 <TbReport
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.BILLINGREPORT)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.BILLINGREPORT)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Billing Report
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.ORDERHISTORY)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.ORDERHISTORY)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.OREDERHISTORY) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Order History"}>
//                 <MdWorkHistory
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.ORDERHISTORY)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.ORDERHISTORY)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Order History
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.ORDERREPORT)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.ORDERREPORT)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.ORDERREPORT) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Order Report"}>
//                 <TbReportMedical
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.ORDERREPORT)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.ORDERREPORT)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Order Report
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.REFERRAL)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.REFERRAL)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div
//               className={`${
//                 isMenuItemActive(APP_ROUTES.REFERRAL) ? "rounded-md" : ""
//               }`}
//             >
//               <Tooltip placement="right" color="Teal" title={"Referrals"}>
//                 <FaUserDoctor
//                   className={` h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.REFERRAL)
//                       ? "text-white"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.REFERRAL)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Referrals
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.NOTIFICATION)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.NOTIFICATION)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Notifications"}>
//                 <IoNotifications
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.NOTIFICATION)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.NOTIFICATION)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Notification
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={() => handleNavigation(APP_ROUTES.CHANGEPASSWORD)}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.CHANGEPASSWORD)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Settings"}>
//                 <IoSettings
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.CHANGEPASSWORD)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               } ${
//                 isMenuItemActive(APP_ROUTES.CHANGEPASSWORD)
//                   ? "text-white font-semibold text-lg"
//                   : ""
//               }`}
//             >
//               Settings
//             </span>
//           </div>
//         </li>
//         <li className="w-full">
//           <div
//             onClick={handleLogout}
//             className={`flex items-center gap-3 cursor-pointer p-2 ${
//               isMenuItemActive(APP_ROUTES.LOGIN)
//                 ? "bg-[#189FAA] rounded-lg"
//                 : ""
//             }`}
//           >
//             <div>
//               <Tooltip placement="right" color="Teal" title={"Logout"}>
//                 <HiOutlineLogout
//                   className={`h-5 w-5 ${
//                     isMenuItemActive(APP_ROUTES.LOGIN)
//                       ? " text-brand-White"
//                       : "text-black"
//                   }`}
//                 />
//               </Tooltip>
//             </div>
//             <span
//               className={`text-bgBlue font-sans font-semibold md:text-base text-sm ${
//                 !isMenuOpen ? "hidden" : ""
//               }`}
//             >
//               Logout
//             </span>
//           </div>
//         </li>
//       </ul>
//       <Modal
//         title="Confirm Logout"
//         width={"25%"}
//         open={logoutModal}
//         onCancel={handleCancel}
//         footer={
//           <div className="mt-6">
//             <button
//               className="mx-1 p-1 w-28 font-semibold text-brand-primaryColor border border-brand-primaryColor rounded-md"
//               onClick={handleCancel}
//             >
//               Cancel
//             </button>
//             <button
//               className="mx-1 p-1 w-28 font-semibold custom_filter text-brand-White rounded-md"
//               onClick={handleOk}
//             >
//               Yes
//             </button>
//           </div>
//         }
//       >
//         Are you sure you want to log out?
//       </Modal>
//       <Modal
//         title="Alert"
//         open={showWarning}
//         onOk={handleVideoCallRoute}
//         onCancel={handleVideoCallRoute}
//         width={"30%"}
//         footer={
//           <div className="flex items-end gap-1 justify-end">
//             <button
//               className="mx-1 p-1 w-32 h-8 text-[#189FAA] font-semibold  rounded-md  bg-white border-2 border-[#979797] mt-2"
//               onClick={handleVideoNavigation}
//             >
//               Leave
//             </button>
//             <button
//               className="mx-1 p-1 w-32 h-8 font-semibold text-white bg-[#189FAA] rounded-md"
//               onClick={handleVideoCallRoute}
//             >
//               Stay on page
//             </button>
//           </div>
//         }
//       >
//         Are you sure you want to close the consultation?
//       </Modal>
//     </div>
//   );
// }

// export default Sidemenu;


import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { useLocation } from "react-router-dom";

import { APP_ROUTES } from "../PageRouting/PageRoutes";

import { BiSolidDashboard } from "react-icons/bi";

import {
  MdAnalytics,
  MdOutlineSwitchAccount,
  MdWorkHistory,
  MdJoinLeft,
  MdDiscount,
} from "react-icons/md";

import { HiOutlineLogout, HiUserGroup } from "react-icons/hi";

import {
  LuCalendarClock,
  LuPresentation,
  LuChevronDown,
} from "react-icons/lu";

import {
  TbReport,
  TbReportMedical,
} from "react-icons/tb";

import {
  FaCcMastercard,
  FaClipboardList,
  FaProcedures,
  FaUserMd,
  FaWpforms,
  FaFileInvoice,
} from "react-icons/fa";

import {
  IoNotifications,
  IoSettings,
} from "react-icons/io5";

import { CiViewList } from "react-icons/ci";
import { PiUserListFill } from "react-icons/pi";
import { BsCashCoin } from "react-icons/bs";

import memberShip from "../Assets/Images/SideMenuSVG/membershipIcon.svg";

import AppointmentService from "../Services/AppointmentService";
import { useNavigation } from "../Context/NavigationContext";
import { useDispatch } from "react-redux";
import { RESET_STORE } from "../store";


function Sidemenu({ isMenuOpen, handleSideBarMenu }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { navigate } = useNavigation();

  // ---------------------------------------------------------
  // STATE
  // ---------------------------------------------------------

  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isRpmSubMenuOpen, setIsRpmSubMenuOpen] = useState(false);

  const [logoutModal, setLogoutModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [pageRoute, setPageRoute] = useState("");

  // ---------------------------------------------------------
  // USER
  // ---------------------------------------------------------

  const loggedUserObj = sessionStorage.getItem("login_result");

  const loggedUser = loggedUserObj
    ? JSON.parse(loggedUserObj)
    : null;

  const isSuperAdmin =
    loggedUser?.user?.rolecode === "SUPERADMIN";

  // ---------------------------------------------------------
  // ROUTE HELPERS
  // ---------------------------------------------------------

  const isMenuItemActive = (path) => {
    return location.pathname === path;
  };

  const accountRoutes = [
    APP_ROUTES.ACCOUNTS,
    APP_ROUTES.CLINIC,
    APP_ROUTES.USER,
    APP_ROUTES.USERCLINICS,
    APP_ROUTES.USERTEMPLATES,
    APP_ROUTES.ENROLLEDUSER,
  ];

  const rpmRoutes = [
    APP_ROUTES.RPMDASHBOARD,
    APP_ROUTES.RPMVITALPARAMS,
    APP_ROUTES.RPMTASKFREQUENCY,
    APP_ROUTES.DEVICESETUP,
    APP_ROUTES.RPMACTIVITYREPORT,
  ];

  const isAccountsRoute = accountRoutes.includes(
    location.pathname
  );

  const isRpmRoute = rpmRoutes.includes(
    location.pathname
  );

  // ---------------------------------------------------------
  // NAVIGATION
  // ---------------------------------------------------------

  const handleNavigation = (path) => {
    if (!path) return;

    // Video call warning
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(path);
      setShowWarning(true);
      return;
    }

    // Keep submenu open when navigating inside it
    if (!accountRoutes.includes(path)) {
      setIsSubMenuOpen(false);
    }

    if (!rpmRoutes.includes(path)) {
      setIsRpmSubMenuOpen(false);
    }

    navigate(path);
  };

  // ---------------------------------------------------------
  // ACCOUNTS TOGGLE
  // ---------------------------------------------------------

  const toggleAccountsMenu = () => {
    // If collapsed, first expand sidebar
    if (!isMenuOpen) {
      handleSideBarMenu();

      setIsSubMenuOpen(true);
      setIsRpmSubMenuOpen(false);

      return;
    }

    setIsSubMenuOpen((prev) => !prev);
    setIsRpmSubMenuOpen(false);
  };

  // ---------------------------------------------------------
  // RPM TOGGLE
  // ---------------------------------------------------------

  const toggleRpmMenu = () => {
    // If collapsed, first expand sidebar
    if (!isMenuOpen) {
      handleSideBarMenu();

      setIsRpmSubMenuOpen(true);
      setIsSubMenuOpen(false);

      return;
    }

    setIsRpmSubMenuOpen((prev) => !prev);
    setIsSubMenuOpen(false);
  };

  // ---------------------------------------------------------
  // LOGOUT
  // ---------------------------------------------------------

  const handleLogout = () => {
    if (location.pathname === APP_ROUTES.VIDEOCALL) {
      setPageRoute(APP_ROUTES.LOGIN);
      setShowWarning(true);
      return;
    }

    setLogoutModal(true);
  };

  const handleCancel = () => {
    setLogoutModal(false);
  };

  const handleOk = () => {
    sessionStorage.clear();

    dispatch({
      type: RESET_STORE,
    });

    setLogoutModal(false);

    setTimeout(() => {
      navigate(APP_ROUTES.LOGIN);
    }, 500);
  };

  // ---------------------------------------------------------
  // VIDEO CALL
  // ---------------------------------------------------------

  const handleVideoCallRoute = () => {
    setShowWarning(false);
  };

  const handleVideoNavigation = async () => {
    // Logout from video call
    if (
      location.pathname === APP_ROUTES.VIDEOCALL &&
      pageRoute === APP_ROUTES.LOGIN
    ) {
      setShowWarning(false);

      sessionStorage.clear();

      setTimeout(() => {
        navigate(APP_ROUTES.LOGIN);
      }, 500);

      return;
    }

    setShowWarning(false);

    const apptJson = sessionStorage.getItem("appt");

    const selectedAppointment = apptJson
      ? JSON.parse(apptJson)
      : null;

    if (!selectedAppointment) {
      navigate(
        pageRoute || APP_ROUTES.DASHBOARD
      );

      return;
    }

    const payload = {
      appointmentId:
        selectedAppointment.appointmentId,

      patientId:
        selectedAppointment.patientId,

      userId:
        selectedAppointment.userId,

      queueStatus: "N",
    };

    try {
      await AppointmentService.updateQueueStatus(
        payload
      );

      sessionStorage.removeItem("appt");

      navigate(
        pageRoute || APP_ROUTES.DASHBOARD
      );
    } catch (e) {
      console.log(e);
    }
  };

  // =========================================================
  // COMMON MENU ITEM
  // =========================================================

  const MenuItem = ({
    icon: Icon,
    image,
    label,
    route,
  }) => {
    const isActive = isMenuItemActive(route);

    return (
      <li className="w-full">
        <div
          onClick={() => handleNavigation(route)}
          className={`
            group
            flex
            items-center
            h-[40px]
            rounded-md
            cursor-pointer
            transition-all
            duration-200
            ${
              isMenuOpen
                ? "gap-4 px-3 text-sm font-sans"
                : "justify-center px-2"
            }
            ${
              isActive
                ? "bg-[#0CB8A1] font-sans font-semibold"
                : "hover:bg-[#F1FAF8]"
            }
          `}
        >
          {/* ICON */}
          <div
            className={`
              shrink-0
              w-6
              h-6
              flex
              items-center
              justify-center
              rounded-lg
              transition-colors
              duration-200
              ${
                isActive
                  ? "text-white"
                  : "text-[#39434d] group-hover:text-[#0CB8A1]"
              }
            `}
          >
            <Tooltip
              placement="right"
              color="#0CB8A1"
              title={!isMenuOpen ? label : ""}
            >
              {image ? (
                <img
                  src={image}
                  alt={label}
                  className={`
                    w-[16px]
                    h-[16px]
                    object-contain
                    ${
                      isActive
                        ? "brightness-0 invert"
                        : ""
                    }
                  `}
                />
              ) : Icon ? (
                <Icon className="w-[16px] h-[16px]" />
              ) : null}
            </Tooltip>
          </div>

          {/* TEXT */}
          {isMenuOpen && (
            <span
              className={`
                flex-1
                text-[15px]
                font-medium
                whitespace-nowrap
                ${
                  isActive
                    ? "text-white"
                    : "text-[#16285C]"
                }
              `}
            >
              {label}
            </span>
          )}
        </div>
      </li>
    );
  };

  // =========================================================
  // SUB MENU ITEM
  // =========================================================

  const SubMenuItem = ({
    icon: Icon,
    label,
    route,
  }) => {
    const active = isMenuItemActive(route);

    return (
      <li className="w-full">
        <div
          onClick={() => handleNavigation(route)}
          className={`
            group
            flex
            items-center
            gap-3
            min-h-[40px]
            px-3
            rounded-lg
            cursor-pointer
            transition-all
            duration-200
            ${
              active
                ? "bg-[#0CB8A1]"
                : "hover:bg-[#EAF9F6]"
            }
          `}
        >
          {/* SUB ICON */}
          <div
            className={`
              w-7
              h-7
              flex
              items-center
              justify-center
              shrink-0
              ${
                active
                  ? "text-white"
                  : "text-[#71869A] group-hover:text-[#0CB8A1]"
              }
            `}
          >
            {Icon && (
              <Icon className="w-[18px] h-[18px]" />
            )}
          </div>

          {/* SUB TEXT */}
          <span
            className={`
              text-[12px]
              font-medium
              whitespace-nowrap
              ${
                active
                  ? "text-white font-sans"
                  : "text-[#24345D]"
              }
            `}
          >
            {label}
          </span>
        </div>
      </li>
    );
  };

  // =========================================================
  // SUBMENU CONTAINER
  // =========================================================

  const SubMenuContainer = ({ children }) => {
    if (!isMenuOpen) return null;

    return (
      <div
        className="
          ml-3
          mr-1
          mt-1
          mb-2
          pl-2
          pr-1
          py-2
          rounded-md
          bg-[#F8FCFC]
          border-l-[3px]
          border-[#0CB8A1]
        "
      >
        <ul className="flex flex-col gap-1">
          {children}
        </ul>
      </div>
    );
  };

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <>
      {/* =====================================================
          SIDEBAR
      ===================================================== */}

      <div
        className="
          h-full
          w-full
          overflow-hidden
          bg-white
          border
          border-[#E4EFF0]
          rounded-md
          shadow-[0_4px_18px_rgba(15,118,110,0.06)]
          transition-all
          duration-300
        "
      >

        {/* ===================================================
            SIDEBAR HEADER
        =================================================== */}

   

        {/* ===================================================
            MENU AREA
        =================================================== */}

        <div
          className="
           h-screen
            overflow-y-auto
            px-2
            py-4
            scrollbar-thin
            scrollbar-thumb-[#D6EAE8]
            scrollbar-track-transparent
          "
        >
          <ul className="flex flex-col gap-1">

            {/* =================================================
                DASHBOARD
            ================================================= */}

            <MenuItem
              icon={BiSolidDashboard}
              label="Dashboard"
              route={APP_ROUTES.DASHBOARD}
            />

            {/* =================================================
                ANALYTICS
            ================================================= */}

            <MenuItem
              icon={MdAnalytics}
              label="Analytics"
              route={APP_ROUTES.NEWANALYTICS}
            />

            {/* =================================================
                PATIENT LIST
            ================================================= */}

            <MenuItem
              icon={HiUserGroup}
              label="Patient List"
              route={APP_ROUTES.PATIENTLIST}
            />

            {/* =================================================
                RPM
            ================================================= */}

            {loggedUser?.user &&
              (
                loggedUser.user.rolecode ===
                  "SUPERADMIN" ||
                loggedUser.user.rpmApplicable === "Y"
              ) && (
                <li className="w-full">

                  {/* RPM HEADING */}

                  <div
                    onClick={toggleRpmMenu}
                    className={`
                      group
                      flex
                      items-center
                      ${
                        isMenuOpen
                          ? "gap-4 px-3"
                          : "justify-center px-2"
                      }
                      h-[40px]
                      rounded-md
                      cursor-pointer
                      text-[14px]
                      transition-all
                      duration-200
                      ${
                        isRpmRoute ||
                        isRpmSubMenuOpen
                          ? "bg-[#0CB8A1] font-sans font-semibold"
                          : "hover:bg-[#F1FAF8]"
                      }
                    `}
                  >

                    {/* RPM ICON */}

                    <div
                      className={`
                        shrink-0
                        w-6
                        h-6
                        flex
                        items-center
                        justify-center
                        rounded-lg
                        ${
                          isRpmRoute ||
                          isRpmSubMenuOpen
                            ? "text-white"
                            : "text-[#6E8498]"
                        }
                      `}
                    >
                      <Tooltip
                        placement="right"
                        color="#0CB8A1"
                        title={!isMenuOpen ? "RPM" : ""}
                      >
                        <MdOutlineSwitchAccount
                          className="
                            w-[20px]
                            h-[20px]
                          "
                        />
                      </Tooltip>
                    </div>

                    {/* RPM TEXT */}

                    {isMenuOpen && (
                      <>
                        <span
                          className={`
                            flex-1
                            text-[14px]
                            font-medium
                            whitespace-nowrap
                            ${
                              isRpmRoute ||
                              isRpmSubMenuOpen
                                ? "text-white"
                                : "text-[#16285C]"
                            }
                          `}
                        >
                          RPM
                        </span>

                        <LuChevronDown
                          className={`
                            w-5
                            h-5
                            transition-transform
                            duration-200
                            ${
                              isRpmRoute ||
                              isRpmSubMenuOpen
                                ? "text-white"
                                : "text-[#39434d]"
                            }
                            ${
                              isRpmSubMenuOpen
                                ? "rotate-180"
                                : ""
                            }
                          `}
                        />
                      </>
                    )}
                  </div>

                  {/* RPM SUBMENU */}

                  {isRpmSubMenuOpen && (
                    <SubMenuContainer>

                      <SubMenuItem
                        icon={FaClipboardList}
                        label="Dashboard"
                        route={
                          APP_ROUTES.RPMDASHBOARD
                        }
                      />

                      <SubMenuItem
                        icon={CiViewList}
                        label="Vital Parameters"
                        route={
                          APP_ROUTES.RPMVITALPARAMS
                        }
                      />

                      <SubMenuItem
                        icon={FaClipboardList}
                        label="Task / Frequency"
                        route={
                          APP_ROUTES.RPMTASKFREQUENCY
                        }
                      />

                      <SubMenuItem
                        icon={MdJoinLeft}
                        label="Device Setup"
                        route={
                          APP_ROUTES.DEVICESETUP
                        }
                      />

                      <SubMenuItem
                        icon={MdJoinLeft}
                        label="Activity Report"
                        route={
                          APP_ROUTES.RPMACTIVITYREPORT
                        }
                      />

                    </SubMenuContainer>
                  )}
                </li>
              )}

            {/* =================================================
                APPOINTMENTS
            ================================================= */}

            <MenuItem
              icon={LuCalendarClock}
              label="Appointments"
              route={APP_ROUTES.APPOINMENTS}
            />

            {/* =================================================
                PROCEDURES
            ================================================= */}

            <MenuItem
              icon={FaProcedures}
              label="Procedures"
              route={APP_ROUTES.PROCEDURE}
            />

            {/* =================================================
                ACCOUNTS
            ================================================= */}

            <li className="w-full">

              {/* ACCOUNTS HEADING */}

              <div
                onClick={toggleAccountsMenu}
                className={`
                  group
                  flex
                  items-center
                  ${
                    isMenuOpen
                      ? "gap-4 px-3"
                      : "justify-center px-2"
                  }
                  h-[40px]
                  rounded-md
                  cursor-pointer
                  transition-all
                  duration-200
                  ${
                    isAccountsRoute ||
                    isSubMenuOpen
                      ? "bg-[#0CB8A1]"
                      : "hover:bg-[#F1FAF8]"
                  }
                `}
              >

                {/* ACCOUNTS ICON */}

                <div
                  className={`
                    shrink-0
                    w-6
                    h-6
                    flex
                    items-center
                    justify-center
                    rounded-lg
                    ${
                      isAccountsRoute ||
                      isSubMenuOpen
                        ? "text-white"
                        : "text-[#39434d]"
                    }
                  `}
                >
                  <Tooltip
                    placement="right"
                    color="#0CB8A1"
                    title={
                      !isMenuOpen
                        ? "Accounts"
                        : ""
                    }
                  >
                    <MdOutlineSwitchAccount
                      className="
                        w-[20px]
                        h-[20px]
                      "
                    />
                  </Tooltip>
                </div>

                {/* ACCOUNTS TEXT */}

                {isMenuOpen && (
                  <>
                    <span
                      className={`
                        flex-1
                        text-[14px]
                        font-medium
                        whitespace-nowrap
                        ${
                          isAccountsRoute ||
                          isSubMenuOpen
                            ? "text-white"
                            : "text-[#16285C]"
                        }
                      `}
                    >
                      Accounts
                    </span>

                    <LuChevronDown
                      className={`
                        w-5
                        h-5
                        transition-transform
                        duration-200
                        ${
                          isAccountsRoute ||
                          isSubMenuOpen
                            ? "text-white"
                            : "text-[#6D8495]"
                        }
                        ${
                          isSubMenuOpen
                            ? "rotate-180"
                            : ""
                        }
                      `}
                    />
                  </>
                )}
              </div>

              {/* ACCOUNTS SUBMENU */}

              {isSubMenuOpen && (
                <SubMenuContainer>

                  <SubMenuItem
                    icon={CiViewList}
                    label="Account List"
                    route={APP_ROUTES.ACCOUNTS}
                  />

                  <SubMenuItem
                    icon={FaClipboardList}
                    label="Branch List"
                    route={APP_ROUTES.CLINIC}
                  />

                  <SubMenuItem
                    icon={PiUserListFill}
                    label="User List"
                    route={APP_ROUTES.USER}
                  />

                  <SubMenuItem
                    icon={MdJoinLeft}
                    label="Mapped Temp."
                    route={
                      APP_ROUTES.USERTEMPLATES
                    }
                  />

                  <SubMenuItem
                    icon={MdJoinLeft}
                    label="Mapped Clinics"
                    route={
                      APP_ROUTES.USERCLINICS
                    }
                  />

                  {isSuperAdmin && (
                    <SubMenuItem
                      icon={PiUserListFill}
                      label="Enrolled List"
                      route={
                        APP_ROUTES.ENROLLEDUSER
                      }
                    />
                  )}

                </SubMenuContainer>
              )}
            </li>

            {/* =================================================
                TEMPLATES
            ================================================= */}

            <MenuItem
              icon={FaWpforms}
              label="Templates"
              route={APP_ROUTES.TEMPLATES}
            />

            {/* =================================================
                SPECIALITY MAPPING
            ================================================= */}

            <MenuItem
              icon={MdJoinLeft}
              label="Sp. Mapping"
              route={
                APP_ROUTES.SPECIALITYTEMPMAP
              }
            />

            {/* =================================================
                OP SERVICES
            ================================================= */}

            <MenuItem
              icon={FaProcedures}
              label="OP services"
              route={APP_ROUTES.PROCEDURAL}
            />

            {/* =================================================
                VIRTUAL CASH
            ================================================= */}

            <MenuItem
              icon={BsCashCoin}
              label="Virtual Cash"
              route={APP_ROUTES.VIRTUALCASH}
            />

            {/* =================================================
                INVOICE
            ================================================= */}

            <MenuItem
              icon={FaFileInvoice}
              label="Invoice"
              route={APP_ROUTES.INVOICE}
            />

            {/* =================================================
                MEMBERSHIP
            ================================================= */}

            <MenuItem
              image={memberShip}
              label="Membership"
              route={APP_ROUTES.MEMBERSHIP}
            />

            {/* =================================================
                DEMO REQUESTS
            ================================================= */}

            {isSuperAdmin && (
              <MenuItem
                icon={LuPresentation}
                label="Demo Requests"
                route={
                  APP_ROUTES.DEMOREQUESTS
                }
              />
            )}

            {/* =================================================
                DISCOUNT
            ================================================= */}

            <MenuItem
              icon={MdDiscount}
              label="Discount"
              route={APP_ROUTES.DISCOUNT}
            />

            {/* =================================================
                PAYMENTS
            ================================================= */}

            <MenuItem
              icon={FaCcMastercard}
              label="Payments"
              route={APP_ROUTES.PAYMENTS}
            />

            {/* =================================================
                BILLING REPORT
            ================================================= */}

            <MenuItem
              icon={TbReport}
              label="Billing Report"
              route={
                APP_ROUTES.BILLINGREPORT
              }
            />

            {/* =================================================
                ORDER HISTORY
            ================================================= */}

            <MenuItem
              icon={MdWorkHistory}
              label="Order History"
              route={
                APP_ROUTES.ORDERHISTORY
              }
            />

            {/* =================================================
                ORDER REPORT
            ================================================= */}

            <MenuItem
              icon={TbReportMedical}
              label="Order Report"
              route={
                APP_ROUTES.ORDERREPORT
              }
            />

            {/* =================================================
                REFERRALS
            ================================================= */}

            <MenuItem
              icon={FaUserMd}
              label="Referrals"
              route={APP_ROUTES.REFERRAL}
            />

            {/* =================================================
                NOTIFICATION
            ================================================= */}

            <MenuItem
              icon={IoNotifications}
              label="Notification"
              route={
                APP_ROUTES.NOTIFICATION
              }
            />

            {/* =================================================
                SETTINGS
            ================================================= */}

            <MenuItem
              icon={IoSettings}
              label="Settings"
              route={
                APP_ROUTES.CHANGEPASSWORD
              }
            />

            {/* =================================================
                LOGOUT
            ================================================= */}

            <li className="w-full pt-1 pb-2">

              <div
                onClick={handleLogout}
                className={`
                  group
                  flex
                  items-center
                  ${
                    isMenuOpen
                      ? "gap-4 px-3"
                      : "justify-center px-2"
                  }
                  h-[50px]
                  rounded-md
                  cursor-pointer
                  transition-all
                  duration-200
                  hover:bg-[#FFF4F3]
                `}
              >

                <div
                  className="
                    shrink-0
                    w-8
                    h-8
                    flex
                    items-center
                    justify-center
                    rounded-lg
                    text-[#71869A]
                    group-hover:text-[#F05B55]
                  "
                >
                  <Tooltip
                    placement="right"
                    color="#F05B55"
                    title={
                      !isMenuOpen
                        ? "Logout"
                        : ""
                    }
                  >
                    <HiOutlineLogout
                      className="
                        w-[24px]
                        h-[24px]
                      "
                    />
                  </Tooltip>
                </div>

                {isMenuOpen && (
                  <span
                    className="
                      text-[16px]
                      font-medium
                      text-[#16285C]
                      group-hover:text-[#F05B55]
                    "
                  >
                    Logout
                  </span>
                )}

              </div>
            </li>

          </ul>
        </div>
      </div>

      {/* =====================================================
          LOGOUT MODAL
      ===================================================== */}

      <Modal
        title="Confirm Logout"
        width="25%"
        open={logoutModal}
        onCancel={handleCancel}
        footer={
          <div className="mt-6 flex justify-end">

            <button
              className="
                mx-1
                px-5
                py-2
                font-semibold
                text-[#0CB8A1]
                border
                border-[#0CB8A1]
                rounded-lg
                hover:bg-[#EAFBF8]
              "
              onClick={handleCancel}
            >
              Cancel
            </button>

            <button
              className="
                mx-1
                px-6
                py-2
                font-semibold
                text-white
                bg-[#0CB8A1]
                rounded-lg
                hover:bg-[#0AA893]
              "
              onClick={handleOk}
            >
              Yes
            </button>

          </div>
        }
      >
        Are you sure you want to log out?
      </Modal>

      {/* =====================================================
          VIDEO CALL WARNING MODAL
      ===================================================== */}

      <Modal
        title="Alert"
        open={showWarning}
        onOk={handleVideoCallRoute}
        onCancel={handleVideoCallRoute}
        width="30%"
        footer={
          <div className="flex items-end gap-2 justify-end">

            <button
              className="
                px-5
                py-2
                text-[#189FAA]
                font-semibold
                rounded-lg
                bg-white
                border
                border-[#B8C4C7]
              "
              onClick={handleVideoNavigation}
            >
              Leave
            </button>

            <button
              className="
                px-5
                py-2
                font-semibold
                text-white
                bg-[#189FAA]
                rounded-lg
              "
              onClick={handleVideoCallRoute}
            >
              Stay on page
            </button>

          </div>
        }
      >
        Are you sure you want to close the consultation?
      </Modal>
    </>
  );
}

export default Sidemenu;
